import apiClient from 'api/config/apiClient'

export default {
  getFaqCategory(payload) {
    return apiClient.request('faq', payload)
  },
}
